<template>
  <v-container class="pl-3 py-0 my-0" fluid>
    <v-checkbox
      v-model="checkbox"
      label="isEnterprise"
      @change="setValueIsEnterprise($event)"
    ></v-checkbox>
  </v-container>
</template>

<script>
import { usersCollection } from "@/plugins/firebase.js";

export default {
  data() {
    return {
      checkbox: false,
    };
  },
  props: {
    user: Object,
  },
  methods: {
    async setValueIsEnterprise() {
      await usersCollection
        .doc(this.user.id)
        .set({ isEnterprise: this.checkbox }, { merge: true })
        .then(function () {
          console.log("User isEnterprise was updated");
        })
        .catch(function (error) {
          console.error("Error writing document: ", error);
          this.feedback = error;
        });
    },
  },
  created() {
    if (this.user.isEnterprise) {
      this.checkbox = this.user.isEnterprise;
    }
  },
};
</script>

<style>
</style>